// src/checkbox.dom.ts
import { createScope } from "@zag-js/dom-query";
var dom = createScope({
  getRootId: (ctx) => ctx.ids?.root ?? `checkbox:${ctx.id}`,
  getLabelId: (ctx) => ctx.ids?.label ?? `checkbox:${ctx.id}:label`,
  getControlId: (ctx) => ctx.ids?.control ?? `checkbox:${ctx.id}:control`,
  getInputId: (ctx) => ctx.ids?.input ?? `checkbox:${ctx.id}:input`,
  getRootEl: (ctx) => dom.getById(ctx, dom.getRootId(ctx)),
  getInputEl: (ctx) => dom.getById(ctx, dom.getInputId(ctx))
});

export {
  dom
};
